import React, { Component } from "react";
import { page } from "../../Model/Content"; //Include Home
import { Banner } from "../banner/Banner"; //Include Banner
import { Special } from "../special/Special"; //Include Special
import Search from "../search/Search";
import Notification from "../Notification/Notification";
import { Link } from "react-router-dom";
import { Docubytes } from "../Docubytes/Docubytes";
import { StartExploring } from "../startExploring/startExploring";
import { Layout1 } from "../Layout1/Layout1";
import { Layout2 } from "../Layout2/Layout2";
import { Layout3 } from "../Layout3/Layout3";
import { Layout9 } from "../Layout9/Layout9";
import { Layout5 } from "../Layout5/Layout5";
import { Layout7 } from "../Layout7/Layout7";
import { Layout8 } from "../Layout8/Layout8";
import { Layout10 } from "../Layout10/Layout10";
import { Layout11 } from "../Layout11/Layout11";
import { Layout12 } from "../Layout12/Layout12";
import { Layout13 } from "../Layout13/Layout13";
import Allbays from "../Allbays/Allbays";
import { motion } from "framer-motion";
import { Childlock } from "../Childlock/Childlock";
import { Metadata } from "../Metadata/Metadata";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import {
  SVGIcons,
  ImgIcons,
  VirsionCheck,
  Appsflyer,
  withRouter,
} from "../../Helpers/Common";
import { Footerdesk } from "../../components/FooterDesk/Footerdesk";
import Notifcationdesk from "../../components/Notifcationdesk/Notifcationdesk";
import { isMobile } from "react-device-detect";
import { userprofile, getGeoInfo } from "../../Model/Users";
import { ToastContainer } from "react-toastify";
import Header from "../common/Header";
import BarLoader from "react-spinners/BarLoader";

var ImageData = "";
var SVGIcon = "";

ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

class Series extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      DataisLoaded: false,
      VirsionCheckData: "",
      VirsionCheckDataloaded: false,
      SearchClick: false,
      Showallbays: false,
      userData: false,
      isLive: true,
      goldenDIcon: "",
      silverDIcon: "",
      goldenDOriginalIcon: "",
    };
  }

  componentDidMount() {
    //Get Home page
    Appsflyer("Series Page Visited", {});
    getGeoInfo().then((res) => {
      VirsionCheck().then((vcheckres) => {
        this.setState({
          isLive: JSON.parse(vcheckres.data).data.is_live_tv,
          goldenDIcon: JSON.parse(vcheckres.data).data["golden-dweb"],
          silverDIcon: JSON.parse(vcheckres.data).data["silver-dweb"],
          goldenDOriginalIcon: JSON.parse(vcheckres.data).data["d_original"],
        });
        let data = {
          seesionID: localStorage.getItem("session_id"),
          userID: localStorage.getItem("userID")
        }
        userprofile(data).then((userDatares) => {
          if (JSON.parse(userDatares.data.message).success == false) {
            this.props.navigate("/createaccount");
          }
          if (userDatares.data.message == "session_expired") {
            this.props.navigate("/createaccount");
          } else {
            var userDatares = JSON.parse(userDatares.data.message);
            this.setState({
              userData: userDatares.user_data,
              VirsionCheckData: vcheckres,
              VirsionCheckDataloaded: true,
            });

            page("series", res, userDatares.user_data.is_child).then((res) => {
              if (res.data.success == false) {
                this.props.navigate("/createaccount");
              }
              this.setState({
                items: res,
                DataisLoaded: true,
              });
            });
          }
        });
      });
    });
  }

  search() {
    this.setState({
      SearchClick: true,
    });
  }

  //
  SearchClose() {
    this.setState({
      SearchClick: false,
    });
  }

  Notification() {
    this.setState({
      NotificationClick: true,
    });
  }

  //
  NotificationClose() {
    this.setState({
      NotificationClick: false,
    });
  }
  render() {
    const { items, DataisLoaded, VirsionCheckData, VirsionCheckDataloaded } =
      this.state;

    if (DataisLoaded === false || this.state.VirsionCheckDataloaded === false) {
      // return <div className="loader"></div>;
      return (
        <div className="loader">
          <BarLoader color="#ff000f" />
        </div>
      );
    }

    //Search Tab Open

    if (this.state.SearchClick === true) {
      return (
        <Search
          functions={this}
          goldenIcon={this.state.goldenDIcon}
          silverIcon={this.state.silverDIcon}
        />
      );
    }

    // var SeriesData = items.data.home;
    const SeriesDataparse = items.data.home //JSON.parse(JSON.parse(items.data.home));
    var pageData = SeriesDataparse.pageData.lists;
    var Baysdata = SeriesDataparse.bayData;
    var MetaData = JSON.parse(this.state.VirsionCheckData.data).data.page.home;
    // document.addEventListener("scroll", () => {
    //   const header = document.querySelector("header");
    //   if (window.scrollY > 10) {
    //     header.classList.add("head-hide");
    //   } else {
    //     header.classList.remove("head-hide");
    //   }
    // });
    return (
      <>
        <Metadata page="SERIES" />
        <motion.div
          className=""
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
          key="1"
        >
          <div className="banner-overlay dD-block"></div>
          <Header
            userprofile={this.state.userData}
            bayData={Baysdata}
            page={"series"}
            classdata={this}
          />
          {pageData.map((data, index) => {
            if (data.section_layout == "Layout 0") {
              if (this.state.Showallbays === true) {
                return <Allbays functions={this} />;
              }
              return [
                <Banner
                  clsname={"temp11-mov"}
                  key={data.section_layout}
                  BannerDatas={data.contents}
                  goldenIcon={this.state.goldenDIcon}
                  silverIcon={this.state.silverDIcon}
                  goldenOriginalIcon={this.state.goldenDOriginalIcon}
                />,
              ];
            } else if (data.section_layout == "Layout 1") {
              return (
                <div className="latestBay">
                  <Layout1
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 2") {
              return (
                //Special Bay
                <div className="latestBay">
                  <Layout2
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 3") {
              return (
                <div className="latestBay">
                  <Layout3
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 5") {
              return (
                <div className="latestBay">
                  <Layout5
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 7") {
              return (
                <div className="latestBay">
                  <Layout7
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 8") {
              return (
                <div className="latestBay">
                  <Layout8
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 9") {
              return (
                <div className="latestBay">
                  <Layout9
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 10") {
              return (
                <div className="latestBay">
                  <Layout10
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 11") {
              return (
                <div className="latestBay">
                  <Layout11
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 12") {
              //Docubuster of the month
              return (
                <div className="latestBay">
                  <Layout12
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 13") {
              return (
                <div className="latestBay">
                  <Layout13
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else {
              /*<Special
                  SpecialDatas={data.contents}
                  key={data.section_layout}
                  title={data}
                />*/
            }
          })}
          <ToastContainer
            position="bottom-center"
            autoClose={4000}
            hideProgressBar={true}
            closeButton={false}
            theme="light"
          />
          {this.state.userData != false ? (
            <Childlock data={this.state.userData} />
          ) : null}
          <div className="pb-m dD-none"></div>
          <Footerdesk />
          <Mobilemenu active="1" isLive={this.state.isLive} />
        </motion.div>
      </>
    );
  }
}
export default withRouter(Series);
